/**
 * app-search — types + validator for the global search-state of the `_app` layout.
 *
 * Centralizes in the URL the overlays mounted at the `_app` level (for now the
 * multi-account account switcher), so that pasting the URL in another browser
 * reopens exactly the same screen/overlay.
 *
 * Pattern (same as #9 `/?q=`): `validateSearch` omits defaults (it does not pollute the
 * URL in the empty state) and the hosts reflect URL→signals + navigate with
 * `{ replace: true }` on open/close (idempotent, survives back/forward and
 * a pasted URL).
 */

export interface AppLayoutSearch {
  // ── Account switch (multi-account #18) ──────────────────────────────────────
  /** Account switcher open (`?account=switch`). */
  account?: "switch";
}

/**
 * Validates + normalizes the layout's search. Omits defaults to keep the URL
 * clean. Tolerant: unknown values are discarded (it does not break the render).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};

  // ── Account switcher (multi-account) ──
  if (search.account === "switch") {
    out.account = "switch";
  }

  return out;
}
